import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function MessageIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "16"}
      viewBox="0 0 20 16"
    >
      <g id="Emails" transform="translate(-26 -116)">
        <path
          id="Path_10017"
          data-name="Path 10017"
          d="M22,6a2.006,2.006,0,0,0-2-2H4A2.006,2.006,0,0,0,2,6V18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2ZM20,6l-8,5L4,6Zm0,12H4V8l8,5,8-5Z"
          transform="translate(24 112)"
          fill={color || "#bbb"}
        />
      </g>
    </svg>
  );
}
